export default __webpack_public_path__ + "static/media/Bar - Flfilment.1dc36603.png";